import useCheckbox from '@ubeya/shared-web/hooks/Table/useCheckbox';
import React, { useCallback, useEffect, useMemo } from 'react';
import EmployeesContent from './EmployeesContent';

const PublishOneItem = ({
  isShift,
  value,
  onChange,
  generateDisabledFilters,
  branches,
  params: externalParams,
  allowCheckAvailableByTimeAvailability,
  allowCheckEarningsLimit,
  onTotalChange
}) => {
  const selectedItem = { id: Object.keys(value)[0], ...Object.values(value)[0] };

  const params = useMemo(
    () => ({ activeTab: 'active', search: '', filters: selectedItem.filters, branches, ...(externalParams || {}) }),
    [branches, externalParams, selectedItem.filters]
  );
  const defaultChecked = useMemo(() => selectedItem?.audience, [selectedItem?.audience]);

  const checkboxData = useCheckbox({ defaultChecked });

  const handleChangeValue = useCallback(
    (payload) => onChange({ [selectedItem.id]: { ...(value[selectedItem.id] || {}), ...payload } }),
    [onChange, selectedItem.id, value]
  );

  const disabledFilters = useMemo(
    () => (generateDisabledFilters ? generateDisabledFilters(selectedItem?.positionId) : []),
    [generateDisabledFilters, selectedItem?.positionId]
  );

  useEffect(() => {
    handleChangeValue({ audience: checkboxData.value });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxData.value]);

  return (
    <EmployeesContent
      isShift={isShift}
      params={params}
      checkboxData={checkboxData}
      filters={selectedItem.filters}
      item={selectedItem}
      setFilters={(values) => handleChangeValue({ filters: values })}
      disabledFilters={disabledFilters}
      onTotalChange={onTotalChange}
      allowCheckAvailableByTimeAvailability={allowCheckAvailableByTimeAvailability}
      allowCheckEarningsLimit={allowCheckEarningsLimit}
    />
  );
};

export default PublishOneItem;
